import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function CrossTrade() {
  return (
    <>
      <SEO
        title="Vi arrangerer kundetilpassede fragtløsninger til cross trade"
        description="Fastlane tilbyder via vores leverandør database fragtløsninger til cross trade der modsvarer dine transportbehov."
        canonicalUrl="https://fastlane.dk/cross-trade"
      />

      <PageHeader
        title="Cross Trade Road"
        subtitle="Direkte internationale transporter mellem leverandører og slutkunder uden omladning i Danmark."
        breadcrumbs={[
          { label: 'Ydelser', path: '/godstransport-i-europa' },
          { label: 'Cross Trade' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {/* Hvad er cross trade transport? */}
          <div className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <h2 className="text-2xl font-bold text-[#0f2b48]">Hvad er cross trade transport?</h2>
            <p>
              Cross trade er import og eksport af varer mellem firmaer i to lande, hvor køberen (mellemhandleren) er bosiddende i et 3. land. Mellemhandleren i 3. land vil ofte være transportkøber og den der giver instrukserne til transportøren. F.eks. køber et dansk firma varer i Letland og sælger videre til køber i Frankrig. Transporten går direkte fra afsender i Letland til slutmodtager i Frankrig. Altså hverken afhentes eller leveres gods i Danmark, hvor mellemhandleren er bosiddende.
            </p>
            <p>
              Cross trade fragt er relevant for dig som dansk firma, hvis du eksempelvis flytter produktionen til Østeuropa og samtidig ønsker at levere direkte til udenlandske kunder/modtagere. Cross trade forsendelse kan også være en mulighed, hvis dine danske kunder flytter deres produktion til udlandet, og ønsker gods leveret på produktionsstedet, samtidig med at din leverandør eller produktion allerede er placeret udenfor Danmark.
            </p>
          </div>

          {/* Fordelene */}
          <div className="bg-sky-50/60 p-6 sm:p-8 rounded-2xl border border-sky-100 space-y-4">
            <h3 className="text-lg font-bold text-[#0f2b48]">
              Fordelene ved at sende cross trade forsendelser direkte fra afsender landet til det land hvor slutmodtager er bosiddende er i de fleste tilfælde:
            </h3>
            <ul className="space-y-2 text-sm text-slate-700">
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-circle-check text-sky-600 text-xs" aria-hidden="true" />
                <span>at det går hurtigere</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-circle-check text-sky-600 text-xs" aria-hidden="true" />
                <span>at det er billigere</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-circle-check text-sky-600 text-xs" aria-hidden="true" />
                <span>at det er bedre for miljøet</span>
              </li>
            </ul>

            <p className="text-sm text-slate-700 pt-3 border-t border-sky-200/60 leading-relaxed">
              Udfordringen ved direkte cross trade fragt er, at man forlader sig på, at afsender sender det de skal og at det er pakket/mærket korrekt. I mange tilfælde ønsker mellemhandleren ikke, at modtager ved hvor godset kommer fra. Således skal det sikres at sendingen papirmæssigt er annonym.
            </p>
            <p className="text-sm text-slate-700 leading-relaxed">
              Specielt, hvis der er brug for at fragte gods rutinemæssigt er det en god idé at investere tiden i at finde den rigtige løsning.
            </p>
          </div>

          {/* Direkte kundetilpasset fragt */}
          <div className="space-y-4 text-slate-700 leading-relaxed text-sm sm:text-base border-t border-slate-200 pt-8">
            <h2 className="text-2xl font-bold text-[#0f2b48]">Direkte kundetilpasset fragt til cross trade</h2>
            <p>
              Fastlane har lavet internationale vejbaserede fragtløsninger til cross trade transport for vores faste kunder i mange år. Har du gods, som f.eks. skal hentes i Italien, Baltikum, Benelux eller Polen og leveres direkte i andre lande end Danmark, så finder vi gerne en ad hoc eller en mere fast fragtløsning til din cross trade. Du velkommen til at sende os en mail på{' '}
              <a href="mailto:booking@fastlane.dk" className="text-sky-700 font-semibold underline">booking@fastlane.dk</a> eller ringe til os på{' '}
              <a href="tel:+4576121230" className="text-slate-900 font-semibold whitespace-nowrap">+45 76 12 12 30</a>. Du kan også sende os en{' '}
              <Link to="/fragtrater" className="text-sky-700 font-semibold underline">forespørgsel</Link>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
